import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React__default__default, { useContext } from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../../node_modules/@flixbus/honeycomb/dist/scss/components/header-nav.scss.js';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import { requiredChildrenValidation } from '../../../prop-types-validators/children-validator.js';
import { HoneyBemContext } from '../../../contexts/honey-bem-context.js';
import { Injecss } from '../../../packages/injecss/injecss.js';

var HeaderNavigation = function (_a) {
  var children = _a.children,
    ariaLabel = _a["aria-label"],
    extraClasses = _a.extraClasses,
    rest = __rest(_a, ["children", 'aria-label', "extraClasses"]);
  var parentBem = useContext(HoneyBemContext);
  var bem = parentBem || HoneyBem.init('header-nav', styles);
  return /*#__PURE__*/React__default__default.createElement(HoneyBemContext.Provider, {
    value: bem
  }, /*#__PURE__*/React__default__default.createElement("nav", __assign({
    "aria-label": ariaLabel,
    className: bem.b(false, [extraClasses, bem.e('nav')])
  }, rest), /*#__PURE__*/React__default__default.createElement("ul", {
    className: bem.e('list')
  }, children)));
};
HeaderNavigation.displayName = 'HeaderNavigation';
HeaderNavigation.propTypes = {
  extraClasses: PropTypes__default.string,
  'aria-label': PropTypes__default.string.isRequired,
  children: requiredChildrenValidation('NavItem') // eslint-disable-line
};

var headerNavigation = Injecss(HeaderNavigation, styles);

export { HeaderNavigation, headerNavigation as default };
